export default __webpack_public_path__ + "static/media/youtube.92f3ecc7.svg";